'use client';

import { Show } from '@clerk/nextjs';
import AppNavSigninButton from './navigation/AppNavSignInButton';
import AppNavUserButton from './navigation/AppNavUserButton';

const ClerkUserAvatar = () => {
  return (
    <Show when="signed-in" fallback={<AppNavSigninButton />}>
      <AppNavUserButton />
    </Show>
  );
};

export default ClerkUserAvatar;
